import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    carousel: (theme) => ({
        '.slick-arrow': {
            '&::after': {
                transform: 'translate(-50%, -50%) rotate(-45deg)'
            },
            '&::before': {
                mt: '2px',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            },
            '&::before, &::after': {
                backgroundColor: theme.colors.plantation,
                borderRadius: 2,
                content: '""',
                height: 4,
                left: '50%',
                opacity: 1,
                position: 'absolute',
                top: '50%',
                transformOrigin: 'center right',
                width: 14
            },

            ':focus-visible': {
                borderRadius: '999px',
                outline: `2px solid ${theme.colors.teal}`,
                outlineOffset: 2
            },

            alignItems: 'center',

            backgroundColor: theme.colors.white,

            border: `solid 1px ${theme.colors.plantation}`,
            borderRadius: '50%',
            bottom: {
                md: 'auto',
                xs: 0
            },
            cursor: 'pointer',
            display: 'flex !important',
            fontSize: 0,
            height: 40,
            justifyContent: 'center',
            lineHeight: 0,
            position: 'absolute',
            top: {
                md: '50%',
                xs: 'auto'
            },
            transition: 'transform .1s ease-in',
            width: 40,
            zIndex: 1
        },
        '.slick-disabled': {
            display: 'none !important'
        },

        '.slick-list': {
            mx: {
                md: 5,
                xs: 0
            },
            overflow: 'hidden'
        },

        '.slick-next': {
            '&:hover, &:focus-visible': {
                transform: {
                    md: 'translateY(-50%) scale(1.05)',
                    xs: 'scale(1.05)'
                }
            },

            right: {
                md: 4,
                xs: 'calc(50% - 48px)'
            },
            transform: {
                md: 'translateY(-50%)',
                xs: 'none'
            }
        },

        '.slick-prev': {
            '&:hover, &:focus-visible': {
                transform: {
                    md: 'translateY(-50%) scaleX(-1) scale(1.05)',
                    xs: 'scaleX(-1) scale(1.05)'
                }
            },

            left: {
                md: 4,
                xs: 'calc(50% - 48px)'
            },
            transform: {
                md: 'translateY(-50%) scaleX(-1)',
                xs: 'scaleX(-1)'
            }
        },

        '.slick-slide': {
            boxSizing: 'border-box',
            height: 'auto',
            px: 2
        },

        '.slick-slide > div': {
            alignItems: 'center',
            display: 'flex',
            height: '100% !important'
        },

        '.slick-slide > div > div': {
            width: '100% !important'
        },

        '.slick-slider': {
            pb: {
                md: 0,
                xs: '52px'
            }
        },

        '.slick-track': {
            alignItems: 'stretch',
            display: 'flex',
            pt: 0.5
        },

        maxWidth: '100%',
        minWidth: 0,
        overflow: 'hidden',
        position: 'relative'
    }),

    carouselSmallItems: {
        '.slick-list': {
            mx: {
                xs: 5
            }
        }
    },

    categoryContainer: {
        '&:hover': {
            '.icon': {
                transform: 'scale(1.15)'
            },

            div: {
                opacity: 1
            },

            textDecoration: 'none !important'
        },

        '.icon': {
            transition: 'transform .15s ease-in',
            width: {
                md: 72,
                xs: 48
            }
        },

        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },

    categoryContainerSmallItems: {
        '.MuiTypography-caption': {
            fontSize: '11px !important',
            lineHeight: '16px !important'
        },

        '.icon': {
            width: 40
        }
    },

    underline: (theme) => ({
        backgroundColor: theme.colors.plantation,
        borderRadius: 1,
        height: 3,
        mt: 1,
        opacity: 0,
        transition: 'opacity .15s ease-in',
        width: 80
    })
} satisfies Record<string, SxProps<Theme>>;

export default styles;
